export const fontFamilies = {
    primary: 'Nunito, sans-serif',
};
